module.exports = __webpack_public_path__ + "img/bb.69d19a06.jpg";